var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-caret-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.47712 4.55469H9.11414C9.21392 4.55471 9.31145 4.58431 9.3944 4.63976C9.47736 4.6952 9.54201 4.774 9.58019 4.86618C9.61838 4.95836 9.62837 5.0598 9.60891 5.15766C9.58945 5.25552 9.54141 5.34542 9.47087 5.41598L6.65236 8.23449C6.55774 8.32908 6.42942 8.38222 6.29563 8.38222C6.16183 8.38222 6.03352 8.32908 5.9389 8.23449L3.12039 5.41598C3.04984 5.34542 3.00181 5.25552 2.98235 5.15766C2.96289 5.0598 2.97288 4.95836 3.01106 4.86618C3.04924 4.774 3.11389 4.6952 3.19685 4.63976C3.27981 4.58431 3.37734 4.55471 3.47712 4.55469Z",
    fill: "#F7F7F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret_down.1b520b8b2ca285682c40c7be184e95b8.svg";
export { ForwardRef as ReactComponent };